"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StorageTypes = Object.freeze({
    COOKIES: 'cookies',
    LOCAL_STORAGE: 'localStorage',
    WINDOW: 'window'
});
exports.default = StorageTypes;
